export const FEE_NUMERATOR = 50n;
export const FEE_DENOMINATOR = 10000n;
export const CLAIM_FEE_NUMERATOR = 25n;
export const FLAT_FEE_SUI = 100000000n;
